/* eslint-disable */
import React from 'react';
import { utility } from '../../framework/utility/utilityProvider';


const CustomTimeLineView = ({ data = [], startDateTime, endDateTime }) => {

    // Generate weekly slots (e.g., every Monday between start and end)
    const generateWeeklyTimeSlots = (start, end) => {
        const slots = [];
        let current = new Date(start);

        // Adjust to the Monday of the current week (or same day if already Monday)
        const dayOffset = (current.getDay() + 6) % 7; // 0 (Sun) -> 6, 1 (Mon) -> 0, ..., 6 (Sat) -> 5
        current.setDate(current.getDate() - dayOffset);

        const formatDate = (date) =>
            date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            }).replace(/ /g, '-');

        while (current <= end) {
            const weekStart = new Date(current);
            const weekEnd = new Date(current);
            weekEnd.setDate(weekEnd.getDate() + 6); // Sunday

            slots.push({
                label: `${formatDate(weekStart)} - ${formatDate(weekEnd)}`,
                start: new Date(weekStart),
                end: new Date(weekEnd)
            });

            current.setDate(current.getDate() + 7); // Next week
        }

        return slots;
    };


    const timeSlots = generateWeeklyTimeSlots(startDateTime, endDateTime);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body p-0 border" style={{ maxHeight: '66.5vh', overflow: 'auto' }}>
                            <table className="table table-bordered mb-0 border">
                                <thead className="border">
                                    <tr className='border'>
                                        {/* <th className='border' key={'image'}>Image</tr> */}
                                        <th className='border' key={'title'} style={{position: 'sticky',backgroundColor: '#fff', zIndex: 5,top: 0, left: 0, width: '200px', minWidth: '200px', maxWidth: '200px', textAlign: 'center' }}>Title</th>
                                        <th className='border' key={'start-date'} style={{ position: 'sticky',backgroundColor: '#fff', zIndex: 5,top: 0, left: 200, width: '200px', minWidth: '200px', maxWidth: '200px', textAlign: 'center' }}>Start Date</th>
                                        <th className='border' key={'end-date'} style={{ position: 'sticky',backgroundColor: '#fff', zIndex: 5,top: 0, left: 400, width: '200px', minWidth: '200px', maxWidth: '200px', textAlign: 'center' }}>End Date</th>
                                        {timeSlots.map((slot, index) => (
                                            <th
                                                className='border'
                                                style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 4,width: '200px', minWidth: '200px', maxWidth: '200px', textAlign: 'center' }}
                                                key={`time-${index}`}
                                            >
                                                {slot.label}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className="border">
                                    {data.map((event, index) => {

                                        const startTime = new Date(utility.convertMilisecondsToDateTimeString(event?.PublishStartDate));
                                        const endTime = new Date(utility.convertMilisecondsToDateTimeString(event?.PublishEndDate));

                                        return (
                                            <tr key={index} style={{ height: '30px' }}>
                                                <td className="border text-center" style={{position: 'sticky', left: 0, zIndex:5 , backgroundColor: '#fff'}}>
                                                    {utility.subString(event?.mediaEpisode.Title, 40)}
                                                </td>

                                                <td className="border text-center" style={{position: 'sticky', left: 200, zIndex:5 , backgroundColor: '#fff'}}>
                                                    {utility.convertMilisecondsToDateString(new Date(event.PublishStartDate).getTime())}
                                                </td>

                                                <td className="border text-center" style={{position: 'sticky', left: 400, zIndex:5, backgroundColor: '#fff' }}>
                                                    {utility.convertMilisecondsToDateString(new Date(event.PublishEndDate).getTime())}
                                                </td>

                                                {/* Render each timeslot cell */}
                                                {timeSlots.map((slot, slotIndex) => {
                                                    const eventStartsThisWeek = startTime <= slot.end && endTime >= slot.start;

                                                    if (eventStartsThisWeek) {
                                                        const eventStartWithinWeek = new Date(Math.max(startTime, slot.start));
                                                        const eventEndWithinWeek = new Date(Math.min(endTime, slot.end));

                                                        const getDayOffsetWithinWeek = (date, weekStart) => {
                                                            return Math.max(0, Math.min(6, Math.floor((date - weekStart) / (1000 * 60 * 60 * 24))));
                                                        };

                                                        const offsetDays = getDayOffsetWithinWeek(eventStartWithinWeek, slot.start);
                                                        const spanDays = getDayOffsetWithinWeek(eventEndWithinWeek, slot.start) - offsetDays + 1;

                                                        const percentLeft = (offsetDays / 7) * 100;
                                                        const percentWidth = (spanDays / 7) * 100;

                                                        return (
                                                            <td
                                                                key={`slot-${index}-${slotIndex}`}
                                                                className="border"
                                                                style={{ position: 'relative', width: '200px', minWidth: '200px' }}
                                                                title={`${event?.mediaEpisode.Title ?? ''} \nStart: ${utility.convertMilisecondsToDateString(event?.PublishStartDate) ?? ''} \nEnd: ${utility.convertMilisecondsToDateString(event?.PublishEndDate)  ?? ''} \nIsUnlimited: ${event.IsUnlimited ?? false} \nExhibitions: ${event.Exhibitions ?? 0} \nExhibitionsUsed: ${event.ExhibitionsUsed ?? 0} \nTotalRuns: ${event.TotalRuns ?? 0}`}
                                                            >
                                                                <div
                                                                    style={{
                                                                        position: 'absolute',
                                                                        left: `${percentLeft}%`,
                                                                        width: `${percentWidth}%`,
                                                                        height: '32px',
                                                                        backgroundColor: event.IsUnlimited ? '#123458' : '#60B5FF',
                                                                        color: event.IsUnlimited ? '#ffffff' : '#030303',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        paddingLeft: '10px',
                                                                        zIndex: 1,
                                                                        top: '4px',
                                                                        borderTopLeftRadius: percentLeft !== 0 ? '5px' : '0',
                                                                        borderBottomLeftRadius: percentLeft !== 0 ? '5px' : '0',
                                                                        borderTopRightRadius: percentLeft + percentWidth !== 100 ? '5px' : '0',
                                                                        borderBottomRightRadius: percentLeft + percentWidth !== 100 ? '5px' : '0',
                                                                    }}
                                                                    title={`${event?.mediaEpisode.Title ?? ''} \nStart: ${utility.convertMilisecondsToDateString(event?.PublishStartDate) ?? ''} \nEnd: ${utility.convertMilisecondsToDateString(event?.PublishEndDate)  ?? ''} \nIsUnlimited: ${event.IsUnlimited ?? false} \nExhibitions: ${event.Exhibitions ?? 0} \nExhibitionsUsed: ${event.ExhibitionsUsed ?? 0} \nTotalRuns: ${event.TotalRuns ?? 0}`}
                                                                >
                                                                    {/* Exhibition bubbles */}
                                                                    {(event.programSchedule ?? []).filter(exh => {
                                                                        const exDate = new Date(exh.SlotDateTime);
                                                                        return exDate >= slot.start && exDate <= slot.end;
                                                                    }).map((exh, j) => {
                                                                        const exDate = new Date(exh.SlotDateTime);
                                                                        const dayOffset = getDayOffsetWithinWeek(exDate, slot.start);
                                                                        const bubbleLeft = (dayOffset / 7) * 100;

                                                                        return (
                                                                            <div
                                                                                key={`exh-${j}`}
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    left: `calc(${bubbleLeft}% + ${j * 22}px)`,
                                                                                    top: '5px',
                                                                                    backgroundColor: '#FE4F2D',
                                                                                    color: 'white',
                                                                                    padding: '1px 7px',
                                                                                    borderRadius: '17px',
                                                                                    fontSize: '14px',
                                                                                    fontWeight: 'bold',
                                                                                    zIndex: 2,
                                                                                }}
                                                                                title={`${exh?.Channel?.FullChannelName ?? ''} \n${utility.convertMilisecondsToDateTimeString(exh?.SlotDateTime) ?? ''}`}
                                                                            >
                                                                                {exh.ExhibitionNumber || '.'}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </td>
                                                        );
                                                    }

                                                    return <td key={`slot-${index}-${slotIndex}`} className="border" />;
                                                })}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomTimeLineView;